var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndicesArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7449 0.118097C15.4665 0.127923 15.211 0.275321 15.0636 0.511156L7.17622 12.5781L2.06645 8.16271C1.84699 7.93507 1.51781 7.8499 1.21482 7.94489C0.913479 8.03824 0.689108 8.29373 0.6367 8.6049C0.584292 8.91771 0.710398 9.23216 0.965887 9.4205L6.80937 14.4779C6.9928 14.6335 7.23518 14.7022 7.47266 14.6678C7.71177 14.6318 7.92304 14.4959 8.05406 14.2944L16.4786 1.42829C16.6588 1.16462 16.6735 0.823966 16.5179 0.545549C16.3623 0.26877 16.0626 0.103357 15.7449 0.118097Z",
    fill: "#5ED3F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicesArrow);
export default __webpack_public_path__ + "static/media/indices_arrow.b376393ce1c046d13637256e991f7f98.svg";
export { ForwardRef as ReactComponent };